import {
  ImmunizationTypeEnum,
  ProviderCredentialingImmunization,
  ProviderCredentialingInsurances,
  ProviderCredentialingMisc,
  ProviderCredentialingRatesAndDifferentials,
} from '../../../../api';
import { FORM_NAME as IMMUNIZATION_FORM_NAME } from '../../../../app/components/ImmunizationFormGroup';
import { FORM_NAME as INSURANCE_FORM_NAME } from '../../../../app/components/InsuranceFormGroup';
import { FORM_NAME as MISCELLANEOUS_FORM_NAME } from '../../../../app/components/MiscellaneousFormGroup';

export interface ProviderOtherInfoFormData {
  [INSURANCE_FORM_NAME]: ProviderCredentialingInsurances[typeof INSURANCE_FORM_NAME];
  [IMMUNIZATION_FORM_NAME]: Array<{
    issue_date: Date;
    expiration_date: Date;
    file__file: string;
    exempt: boolean;
    type: ImmunizationTypeEnum;
  }>;
  [MISCELLANEOUS_FORM_NAME]: Array<{
    title: string;
    issue_date: Date;
    expiration_date: Date;
    file__file: string;
  }>;
}

export type ProviderOtherInfoData = Omit<
  ProviderOtherInfoFormData,
  typeof IMMUNIZATION_FORM_NAME | typeof MISCELLANEOUS_FORM_NAME
> & {
  [IMMUNIZATION_FORM_NAME]: ProviderCredentialingImmunization[typeof IMMUNIZATION_FORM_NAME];
  [MISCELLANEOUS_FORM_NAME]: ProviderCredentialingMisc[typeof MISCELLANEOUS_FORM_NAME];
};

export enum EProviderShifts {
  Day,
  Night,
  Call,
  FullTime,
}

export interface IShiftOption {
  type: EProviderShifts;
  label: string;
  availabilityControlName: string;
  controlName: keyof ProviderCredentialingRatesAndDifferentials;
  tooltipText: string;
}

export const SHIFT_LABEL_INFO_TEXT =
  'Please select from the available shift types below. Health organizations will only be able to schedule you for the shift types you selected on dates you have listed as available. You can change your target rates and shifts at any point in time.';

export const SHIFT_OPTIONS: IShiftOption[] = [
  {
    type: EProviderShifts.Day,
    label: 'Day Shift',
    availabilityControlName: 'shift_rate_day_availability',
    controlName: 'shift_rate_day',
    tooltipText:
      'A Day Shift is defined as any shift that occurs during the daytime hours(does not cross mid-night).',
  },
  {
    type: EProviderShifts.Night,
    label: 'Night Shift',
    availabilityControlName: 'shift_rate_night_availability',
    controlName: 'shift_rate_night',
    tooltipText: 'A Night Shift is defined as any shift that crosses the midnight (00:00) hour.',
  },
  {
    type: EProviderShifts.Call,
    label: 'Call Shift',
    availabilityControlName: 'shift_rate_call_availability',
    controlName: 'shift_rate_call',
    tooltipText:
      'A Call Shift is defined as any shift that requires you be available by phone and able to respond to the hospital within 30 minutes.',
  },
  {
    type: EProviderShifts.FullTime,
    label: '24hr Onsite Shift',
    availabilityControlName: 'shift_rate_24h_availability',
    controlName: 'shift_rate_24h',
    tooltipText:
      'A 24-hour onsite shift is defined as any shift that requires you be on hospital property and available for 24 hours.',
  },
];
